import Input from '../../ui/Input';
import Heading from '../../ui/Heading';
import Button from '../../ui/Button';
import Toggle from '../../ui/Toggle';
import { useStepFiveInputs } from './bountiesHooks/useStepFiveInputs';
import { useState } from 'react';
import Modal from '../../ui/Modal';
import ModalBox from '../../ui/ModalBox';
import TermsAndConditionModal from './TermsAndConditionModal';

import CharacterLimit from '../../ui/CharacterLimit';
import UploadLogoComponent from './UploadLogoComponent';
import FloatingButtons from '../../ui/FloatingButtons';
import Loader from '../../ui/Loader';
import ButtonNew from '../../ui/ButtonNew';

function StepFive({ setStep, control, errors, getValues, clearErrors, loading, isGreenpillEvent, handleSubmit, onSubmit, onSaveProgress, saving }) {
    const {
        hasBackerField,
        backerNameField,
        backerLogoField,
        backerMessageField,
        initiatorNameField,
        initiatorLogoField,
        hasInitiatorField,
    } = useStepFiveInputs(control);

    const [showTerms, setShowTerms] = useState(false);

    const openTermsModal = (event) => {
        if (loading) return;
        event.preventDefault();
        setShowTerms(true);
    };

    const closeTermsModal = () => {
        setShowTerms(false);
    };

    const handleFormSubmit = () => {
        // Manually call the onSubmit function passed from BountiesMain
        handleSubmit(onSubmit)();
        closeTermsModal();
    };

    // Check if there are any validation errors
    const hasValidationErrors = errors && Object.keys(errors).length > 0;

    // Determine if button should be disabled
    const shouldDisable = loading || hasValidationErrors;

    return (
        <div className="relative">
            <div className="p-12 pb-16   rounded-md min-h-full flex flex-col justify-between ">
                <div>
                    <div className=" mb-6">
                        <div className="flex gap-2 items-center">
                            <Heading type="xsmall" className="  text-textPrimary">
                                Does the bounty have a sponsor or backer ?
                            </Heading>
                            <Toggle
                                valuee={hasBackerField.value}
                                onChangeFn={() => {
                                    if (getValues()?.hasBacker) {
                                        clearErrors('backerName');
                                        clearErrors('backerLogo');
                                        hasBackerField.onChange(false);
                                        return;
                                    }
                                    if (!getValues()?.hasBacker) hasBackerField.onChange(true);
                                }}
                            />
                        </div>
                        <p className="text-sm text-textSecondary">
                            Select this option if you wish to display the bounty <br /> sponsor/backer's logo and name
                            on the bounty?
                        </p>
                    </div>
                    {hasBackerField.value && (
                        <div className="mb-6 pb-6 border-b-2 border-borderUnderline ">
                            <div className="my-6">
                                <Heading type="xsmall" className="capitalize mb-2 text-textPrimary">
                                    Enter sponsor or backer's name <sup className="text-lg relative top-[1px]">*</sup>
                                </Heading>
                                <Input
                                    {...backerNameField}
                                    type="text"
                                    placeholder={'Mention the name that will appear on bounties & impact certs'}
                                    className={'w-[100%]'}
                                    error={errors?.backerName?.message}
                                />
                                <div className="mt-1">
                                    <CharacterLimit
                                        min={backerNameField.value ? backerNameField.value.length : 0}
                                        max={35}
                                    />
                                </div>
                            </div>

                            <div className="my-6">
                                <Heading type="xsmall" className="capitalize mb-2 text-textPrimary">
                                    Upload sponsor or backer's logo <sup className="text-lg relative top-[1px]">*</sup>
                                </Heading>

                                <UploadLogoComponent
                                    outerPadding=""
                                    fieldName={backerLogoField}
                                    errorField={'backerLogo'}
                                    errors={errors}
                                    size="20X20"
                                />
                            </div>
                            <div className="my-6">
                                <Heading type="xsmall" className="capitalize mb-2 text-textPrimary">
                                    Enter Sponsor Message
                                </Heading>
                                <Input
                                    {...backerMessageField}
                                    type="text"
                                    placeholder={'Add sponsor message if any, optional'}
                                    className={'w-[100%]'}
                                    error={errors?.backerMessage?.message}
                                />
                                <div className="mt-1">
                                    <CharacterLimit
                                        min={backerMessageField.value ? backerMessageField.value.length : 0}
                                        max={80}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* <div className="mb-6">
                        <div className="flex gap-2 items-center">
                            <Heading type="xsmall" className="  text-textPrimary">
                                Does the bounty have an Initiator ?
                            </Heading>
                            <Toggle
                                valuee={hasInitiatorField.value}
                                onChangeFn={() => {
                                    if (getValues()?.hasInitiator) {
                                        clearErrors('initiatorName');
                                        hasInitiatorField.onChange(false);
                                        return;
                                    }
                                    if (!getValues()?.hasInitiator) hasInitiatorField.onChange(true);
                                }}
                            />
                        </div>
                        {hasInitiatorField.value && (
                            <>
                                <div className="my-6">
                                    <Heading type="xsmall" className=" mb-2 text-textPrimary">
                                        Enter Initiator's name
                                    </Heading>
                                    <Input
                                        {...initiatorNameField}
                                        type="text"
                                        error={errors?.initiatorName?.message}
                                        placeholder={'Mention the name that will appear on bounties & impact certs'}
                                        className={'w-[100%]'}
                                    />
                                    <div className="mt-1">
                                        <CharacterLimit
                                            min={initiatorNameField.value ? initiatorNameField.value.length : 0}
                                            max={35}
                                        />
                                    </div>
                                </div>

                                <div className="my-6">
                                    <Heading type="xsmall" className=" mb-2 text-textPrimary">
                                        Upload Initiator's image
                                    </Heading>

                                    <UploadLogoComponent
                                        outerPadding=""
                                        fieldName={initiatorLogoField}
                                        errorField={'initiatorLogo'}
                                        errors={errors}
                                    />
                                </div>
                            </>
                        )}
                    </div> */}
                </div>
            </div>
            <FloatingButtons>
                <div className="flex items-center gap-3">
                    <ButtonNew
                        type="button"
                        fixedMinWidth={false}
                        variant="neutral"
                        className='min-w-16 text-neutral600'
                        size="sm"
                        onClick={() => setStep(4)}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                            <path d="M1.25586 9.4986L8.14899 2.60547L9.26857 3.72505L4.2867 8.70693L17.4171 8.70693L17.4171 10.2903L4.2867 10.2903L9.26857 15.2721L8.14899 16.3917L1.25586 9.4986Z" fill="currentColor" />
                        </svg>
                    </ButtonNew>

                    <ButtonNew
                        type="button"
                        fixedMinWidth={true}
                        variant="neutral"
                        size="sm"
                        onClick={onSaveProgress}
                        disabled={saving}
                    >
                        {saving ? <Loader /> : 'Save as Draft'}
                    </ButtonNew>
                </div>
                {/* <Button type="button" onClick={() => setStep(5)} size="small">
                    Next
                </Button> */}
                <Modal>
                    <Modal.Button
                        className={`flex gap-2 items-center ${shouldDisable ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        opens={shouldDisable ? '' : 'termsandcondition'}
                        onClick={(e) => {
                            if (shouldDisable) {
                                e.preventDefault();
                                return;
                            }
                        }}
                    >
                        <ButtonNew
                            type="button"
                            disabled={shouldDisable}
                            fixedMinWidth={true}
                            variant="blue"
                            size="sm" >
                            {loading ? <Loader /> : 'Create Bounty'}
                        </ButtonNew>

                    </Modal.Button>
                    <Modal.Window name={'termsandcondition'}>
                        <TermsAndConditionModal onSubmit={handleFormSubmit} loading={loading} />
                    </Modal.Window>
                </Modal>
            </FloatingButtons>
        </div>
    );
}

export default StepFive;
